import { useInput } from "@redotech/react-util/form";
import CheckIcon from "@redotech/redo-icons/check.svg";
import { EmailInputMessageType } from "@redotech/redo-model/conversation/message-parser-utils";
import { input, nonEmptyValidator } from "@redotech/ui/form";
import { optionalEmailValidator } from "@redotech/web-util/form";
import { memo } from "react";
import { RedoButton } from "../../arbiter-components/buttons/redo-button";
import { RedoTextInput } from "../../arbiter-components/input/redo-text-input";
import { Flex } from "../../flex";
import * as emailInputBubbleCss from "./email-input-bubble.module.css";

const emailInput = input<string>({
  validator: (value: string) => [
    ...optionalEmailValidator(value),
    ...nonEmptyValidator(value),
  ],
});

//TODO remove this when we remove the rest of concierge code
/**
 * @deprecated
 * This component is no longer generated by Concierge, but old conversations
 * still rely on this component to render conversation history. It exists in a
 * readonly state.
 */
export const EmailInputBubble = memo(function EmailInputBubble({
  message,
}: {
  message: EmailInputMessageType;
}) {
  const input = useInput(
    emailInput,
    message.structuredContent?.customerEmail || "",
  );

  return (
    <Flex
      align="flex-end"
      as="form"
      className={emailInputBubbleCss.emailInputBubbleContainer}
      dir="row"
      gap="md"
      px="lg"
      py="md"
    >
      <Flex dir="column" w="full">
        {/* This column was necessary because className on RedoTextInput is applied to a child of the input container */}
        <RedoTextInput
          label="Email"
          placeholder="Enter your email"
          setValue={input.setValue}
          state="disabled"
          value={input.value}
        />
      </Flex>
      <RedoButton disabled hierarchy="primary" IconLeading={CheckIcon} />
    </Flex>
  );
});
